export const formatMoney = (value: string | number): string => {
  const formattedNumber = value
    .toString()
    .split('')
    .reverse()
    .reduce(
      (acc: string[], letter: string, index: number) =>
        (index + 1) % 3 === 0 ? [...acc, letter, ' '] : [...acc, letter, ''],
      [],
    )
    .reverse()
    .join('')

  return `${formattedNumber} ₽`
}

export const formatYears = (number: number): string => {
  const computePostfix = (number: number): string => {
    const cases = ['год', 'года', 'лет']
    const indexes = [2, 0, 1, 1, 1, 2]

    if (number % 100 > 4 && number % 100 < 20) {
      return cases[2]
    } else if (number % 10 < 5) {
      return cases[indexes[number % 10]]
    }

    return cases[indexes[5]]
  }

  return `${number} ${computePostfix(number)}`
}
